module.exports = __webpack_public_path__ + "img/Quiet-Cove-020.97814658.jpg";